import { Box, FormControl, MenuItem, Select, Typography, Chip, InputLabel } from '@mui/material';
import standalone from '../../../../icons/standalone.png';
import { useTriConnection } from './hooks';
import ActiveCommonDialog from './ActiveCommonDialog';
import { useAuthForm } from '../../../Auth/hooks';

interface StatusData {
  active2observer_connection_alive: boolean | undefined;
  ha_state: string;
  active2standby_connection_alive: boolean;
  standby2observer_connection_alive: boolean;
}

const ActiveComponent = () => {

  const { data, isLoading, error, activeSetting, handleChange, handleConfirm, dialogType, handleDialogClose, openDialog } = useTriConnection()

  const { statusData, statusError } = useAuthForm()

  const epochmilliseconds = statusData?.last_state_change;
  const lastActiveDate = epochmilliseconds !== undefined ? new Date(epochmilliseconds) : null;
  const currentDate = new Date();

  const getTimeDifference = () => {
    if (!lastActiveDate) return null;

    const diffMs = currentDate.getTime() - lastActiveDate.getTime();
    if (diffMs < 0) {
      return { days: 0, hours: 0, minutes: 0 };
    }
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return { days, hours, minutes };
  };

  const timeDiff = getTimeDifference();

  const boxDimensions = {
    width: { xs: 170, sm: 190, md: 210, lg: 230, xl: 250, },
    height: { xs: 150, sm: 170, md: 190, lg: 210, xl: 220, },
  };

  const ChipComponent = ({ statusData }: { statusData?: StatusData }) => {
    const label = (data?.primary_address === data?.active_server_address)
      ? 'Active'
      : 'Standby';
    const color = data?.primary_address === data?.active_server_address
      ? 'success'
      : 'default';

    return (
      <Chip label={label} color={color} />
    );
  };

  return (
    <>
      <Box
        id="standalone-box"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          // width: 250,
          // height: 240,
          width: boxDimensions.width,
          height: boxDimensions.height,
          justifyContent: 'center',
          // marginBottom: 2,
          backgroundColor: 'var(--card)',
          boxShadow: 3,
          borderRadius: 4,
          padding: 2,
        }}
      >
        <img src={standalone} alt="Standalone" style={{ width: "2rem", height: "2rem" }} />
        <Typography sx={{ mt: 1 }}>{data?.primary_address === data?.active_server_address ? 'Primary' : 'Secondary'}</Typography>
        {/* <Typography sx={{ mt: 1 }}>{data?.primary_address}</Typography> */}
        <Typography sx={{ mt: 1 }}>{data?.active_server_address}</Typography>
        <Chip label="Active" color="success" />
        {/* {statusData ? <ChipComponent statusData={statusData} /> : <Chip label="Loading..." />} */}
        <Typography sx={{ mt: 1 }}>
          Active for {timeDiff ?
            `${timeDiff.days} ${timeDiff.days === 1 ? 'day' : 'days'}, ` +
            `${timeDiff.hours} ${timeDiff.hours === 1 ? 'hour' : 'hours'}, ` +
            `${timeDiff.minutes} ${timeDiff.minutes === 1 ? 'minute' : 'minutes'}`
            : 'Loading...'}
        </Typography>
        <Box sx={{ width: "100%" }}>
          <FormControl size="small" fullWidth>

            {/* <InputLabel id="demo-simple-select-label">Actions</InputLabel> */}
            <Select
              value={activeSetting}
              onChange={handleChange}
              displayEmpty
            // inputProps={{ 'aria-label': 'Without label' }}
            >
              <MenuItem value="" disabled>
                <em>Actions</em>
              </MenuItem>
              <MenuItem value="switch_to_standby_server" disabled={statusData?.active2standby_connection_alive === false}>Switch to standby server</MenuItem>
              <MenuItem value="break_redundancy">Break redundancy</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {dialogType && (
        <ActiveCommonDialog
          open={openDialog}
          onClose={handleDialogClose}
          onConfirm={handleConfirm}
          dialogType={dialogType}
        />
      )}
    </>
  );
};

export default ActiveComponent;